(() => {
  const configNode = document.getElementById('ZhopuCountryLanguageConfig');
  const form = document.getElementById('ZhopuCountryLanguageForm');
  if (!configNode || !form || window.Shopify?.designMode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const available = config.languages;
  const current = config.locale;
  const bootstrap = document.querySelector('[data-zhopu-premium-bootstrap]');
  const currentCountry = bootstrap?.dataset.country || '';
  let countries = [];
  try { countries = JSON.parse(bootstrap?.querySelector('[data-zhopu-country-data]')?.textContent || '[]'); } catch {}
  const validCountry = value => countries.some(country => country.iso === value);
  const countryKey = 'zhopu-country-choice-v1';
  const countrySessionKey = 'zhopu-country-session-v1';
  const valid = value => ['es', 'en'].includes(value) && available.includes(value);
  const spanishCountries = new Set('ES MX GT BZ HN SV NI CR PA CU DO PR CO VE EC PE BO PY CL AR UY BR HT GF GP MQ BL MF'.split(' '));
  const manualKey = 'zhopu-language-choice-v1';
  const sessionKey = 'zhopu-language-session-v1';
  const attemptKey = 'zhopu-localization-attempt-v2';
  const readCookie = key => {
    try { return document.cookie.split('; ').find(row => row.startsWith(key + '='))?.slice(key.length + 1) || ''; }
    catch { return ''; }
  };
  const read = (key, persistent) => {
    try { return (persistent ? localStorage : sessionStorage).getItem(key) || readCookie(key); }
    catch { return readCookie(key); }
  };
  const write = (key, value, persistent) => {
    try { (persistent ? localStorage : sessionStorage).setItem(key, value); } catch {}
    try { document.cookie = key + '=' + value + '; Path=/; SameSite=Lax; Secure' + (persistent ? '; Max-Age=15552000' : ''); } catch {}
    return read(key, persistent) === value;
  };
  const getManual = () => {
    const [language, expires] = read(manualKey, true).split(':');
    return valid(language) && Number(expires) > Date.now() ? language : '';
  };
  let interacted = false;
  const getManualCountry = () => {
    const [country, expires] = read(countryKey, true).split(':');
    return validCountry(country) && Number(expires) > Date.now() ? country : '';
  };
  const rememberCountry = value => {
    if (!validCountry(value)) return;
    interacted = true;
    write(countryKey, value + ':' + (Date.now() + 15552000000), true);
  };
  document.addEventListener('zhopu:country-choice', event => rememberCountry(event.detail?.country));
  const remember = value => {
    if (!valid(value)) return;
    interacted = true;
    write(manualKey, value + ':' + (Date.now() + 15552000000), true);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-language-switcher] button[name="locale_code"], [data-language-switcher] button[name="language_code"]');
    if (button) remember(button.value);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target === form) return;
    const source = event.target;
    if (!(source instanceof HTMLFormElement) || !new URL(source.action, location.href).pathname.endsWith('/localization')) return;
    const submitter = event.submitter;
    const chosen = ['locale_code', 'language_code'].includes(submitter?.name)
      ? submitter.value : source.querySelector('[name="locale_code"], [name="language_code"]')?.value;
    remember(chosen);
    const chosenCountry = source.querySelector('[name="country_code"]')?.value;
    if (chosenCountry) rememberCountry(chosenCountry);
    const returnInput = source.querySelector('[name="return_to"]');
    if (returnInput) returnInput.value = location.pathname + location.search + location.hash;
  }, true);
  ['pointerdown', 'keydown', 'input', 'submit'].forEach(type => {
    document.addEventListener(type, () => { interacted = true; }, { capture: true, once: true });
  });
  if (/bot|crawl|spider|lighthouse|pagespeed/i.test(navigator.userAgent)) return;
  const apply = (language, country) => {
    language = valid(language) ? language : current;
    country = validCountry(country) ? country : currentCountry;
    if ((current === language && currentCountry === country) || interacted) return;
    const previous = Number(read(attemptKey, false));
    if (previous && Date.now() - previous < 60000) return;
    if (!write(attemptKey, String(Date.now()), false)) return;
    form.querySelector('[name="language_code"]').value = language;
    form.querySelector('[name="country_code"]').value = country;
    form.querySelector('[name="return_to"]').value = location.pathname + location.search + location.hash;
    form.submit();
  };
  const manual = getManual();
  const manualCountry = getManualCountry();
  const [cached, expires] = read(sessionKey, false).split(':');
  const [cachedCountry, countryExpires] = read(countrySessionKey, false).split(':');
  const cachedLanguage = valid(cached) && Number(expires) > Date.now() ? cached : '';
  const savedCountry = validCountry(cachedCountry) && Number(countryExpires) > Date.now() ? cachedCountry : '';
  if ((manual || cachedLanguage) && (manualCountry || savedCountry)) {
    apply(manual || cachedLanguage, manualCountry || savedCountry);
    return;
  }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 2000);
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
    credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal
  }).then(response => {
    if (!response.ok) throw new Error('localization-unavailable');
    return response.json();
  }).then(data => {
    const country = data?.detected_values?.country?.handle;
    if (typeof country !== 'string' || !/^[A-Z]{2}$/.test(country)) return;
    const language = spanishCountries.has(country) ? 'es' : 'en';
    if (valid(language)) write(sessionKey, language + ':' + (Date.now() + 1800000), false);
    if (validCountry(country)) write(countrySessionKey, country + ':' + (Date.now() + 1800000), false);
    apply(getManual() || language, getManualCountry() || country);
  }).catch(() => { apply(manual || cachedLanguage, manualCountry || savedCountry); }).finally(() => clearTimeout(timeout));
})();
